import script from "./SalesLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesLayout.vue?vue&type=script&setup=true&lang=js"

import "./SalesLayout.vue?vue&type=style&index=0&id=5dcc27a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dcc27a8"]])

export default __exports__